import { ValidarEmailHelper } from "../../../helpers";
const validarEmailHelper = new ValidarEmailHelper();

export class Usuario {
  nome = null;
  email = null;
  senha = null;
  confirmarSenha = null;
  ativado = null;
  pctPerfilUsuarioId = null;
  padrao = false;
  acessosEmpresasIds = null;
  controleAcesso = false;
  ipAcesso = null;
  horariosAcesso = [];
  
  constructor(usuario) {
    this.nome = usuario.nome;
    this.email = usuario.email;
    this.senha = usuario.senha;
    this.confirmarSenha = usuario.confirmarSenha;
    this.ativado = usuario.ativado;
    this.pctPerfilUsuarioId = usuario.pctPerfilUsuarioId;
    this.padrao = usuario.padrao ?? false;
    if (usuario?.acessosEmpresas?.length > 0) {
      this.acessosEmpresasIds = usuario.acessosEmpresas.map(
        (acessoEmpresa) => acessoEmpresa.id
      );
    }
    this.controleAcesso = usuario.controleAcesso ?? false;
    this.ipAcesso = usuario.ipAcesso || null;
    this.horariosAcesso = usuario.horariosAcesso ?? [];
  }

  verificarSenhaForte(usuario, senhaScore) {
    if (usuario?.senha && senhaScore < 2) return false;
    return true;
  }

  validarEmail() {
    return validarEmailHelper.email(this.email);
  }
}
